angular.module('cfn').directive('variodocButton', variodocButton);

variodocButton.$inject = [
  'externalAccounts',
  'BookinIsoXmlHttp',
  'bookingIsoXmlConfig',
  'bookingImportWizardService'
];

function variodocButton(
  externalAccounts,
  BookinIsoXmlHttp,
  bookingIsoXmlConfig,
  bookingImportWizardService
) {
  return {
    scope: {
      onfinish: '&'
    },
    restrict: 'E',
    template:
      '<button id="fendtStartWizardButton" ng-show="showVarioDocButton" class="btn"' +
      'style="min-width: 130px;height: 27px!important;"' +
      'hasright="{{isoXmlWizardRights}}"' +
      'ng-click="openImportDialog(true)">' +
      '<img src="img/partner/fendt/Combined.svg"/>' +
      '<div ng-if="dataSets.length > 0" class="count">{{dataSets.length}}</div>' +
      '</button>',
    link: function(scope, element, attrs) {
      scope.isoXmlWizardRights = bookingIsoXmlConfig.requiredRights;
      scope.openImportDialog = function(isFendt) {
        if (!app.hasRight(scope.isoXmlWizardRights)) {
          console.error(
            'Booking List: User has not all required rights to use the IsoXML Wizard'
          );
          return;
        }

        bookingImportWizardService
          .openImportDialog(isFendt)
          .then(exitResult => {
            if (exitResult && exitResult.action === 'ok') {
              BookinIsoXmlHttp.allDataSets().then(function(dataSets) {
                scope.dataSets = dataSets;
              });
              if (scope.onfinish) scope.onfinish();
            }
          });
      };
      scope.dataSets = [];

      // if this is shown, we show get the data
      externalAccounts
        .hasCredentials('fendt.varioDoc')
        .then(function(hasCredentials) {
          if (!hasCredentials) {
            return;
          }
          BookinIsoXmlHttp.allDataSets().then(function(dataSets) {
            scope.dataSets = dataSets;
          });
          scope.showVarioDocButton = true;
        });
    }
  };
}
